export default __webpack_public_path__ + "static/media/ELE.69996a2c.png";